const FILM_TRANSFER_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: '',
        textMob: '',
        secondText: 'All Types of Film Reels',
        secondTextMob: 'All Types of',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: true,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: true,
        firstTextLines: [],
        secondTextLines: [{
          id: 1,
          isLeftLine: false,
          isRightLine: true,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: true,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#fff',
          isLineWithSquareMob: true,
        }],
      },
      {
        id: 2,
        text: 'Converted to HD Digital.',
        textMob: 'Film Reels.',
        secondText: '',
        secondTextMob: '',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: false,
        isLeftMob: true,
        isRight: true,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: true,
        isTextWithLineMob: false,
        isSecondTextWithLine: false,
        isSecondTextWithLineMob: false,
        firstTextLines: [{
          id: 1,
          isLeftLine: true,
          isRightLine: false,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: false,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#5F8AA4',
          isLineWithSquareMob: true,
        }],
        secondTextLines: [],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: '8mm Film',
      description: 'Transfer your classic 8mm home movies to crystal-clear digital format.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 2,
      title: 'Super 8mm Film',
      description: 'Digitize your Super 8mm reels with professional precision and care.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 3,
      title: '16mm Film',
      description: 'Professional 16mm film transfer with maximum quality and detail preservation.',
      image: '',
      imageMob: '',
      link: '',
    },
  ],
};

export default FILM_TRANSFER_TYPES_LIST_DATA;
